import type { PropsWithChildren } from 'react';
import type { SlideImageLayoutProps } from './types';
import { FullSizeBackground } from './FullSizeBackground';
import { getSlideImageConfiguration } from './getSlideImageConfiguration';

export const FullSizeBackgroundDataHandler = ({
  image,
  staticContent,
  children,
}: PropsWithChildren<
  Omit<SlideImageLayoutProps, 'hasInteractiveContents'>
>) => {
  const slideImageConfiguration = getSlideImageConfiguration({
    image,
    staticContent,
    // it doesn't matter for full size background image
    hasInteractiveContents: false,
  });

  if (slideImageConfiguration.containedFullBackgroundImage) {
    return (
      <FullSizeBackground
        altText={slideImageConfiguration.containedFullBackgroundImage.altText}
        backgroundImage={
          slideImageConfiguration.containedFullBackgroundImage.backgroundImage
        }
        backgroundImageSize={
          slideImageConfiguration.containedFullBackgroundImage
            .backgroundImageSize
        }
      >
        {children}
      </FullSizeBackground>
    );
  }

  if (slideImageConfiguration.fullBackgroundImage) {
    return (
      <FullSizeBackground
        altText={slideImageConfiguration.fullBackgroundImage.altText}
        backgroundImage={
          slideImageConfiguration.fullBackgroundImage.backgroundImage
        }
        backgroundImageSize={
          slideImageConfiguration.fullBackgroundImage.backgroundImageSize
        }
        shouldShowColorOverlay={
          slideImageConfiguration.fullBackgroundImage.shouldShowColorOverlay
        }
      >
        {children}
      </FullSizeBackground>
    );
  }

  return children;
};
